import "../../css/portfolio.css";
import React, { useState } from "react";
import { render } from "react-dom";
import Typed from "react-typed";
import PortfolioHome from "./PortfolioHome";
import { findDOMNode } from "react-dom";
import Aos from "aos";
import About from "./about";

const Portfolio = () => {
  const [class1, setClass1] = useState("profile col col-lg-3 col-4");

  Aos.init();
  function showOrHideMenu() {
    var element = document.getElementById("navbar-section");
    if( element.classList.contains("navbar-section-show") ){
        element.classList.remove("navbar-section-show")
        element.classList.add("narvar-section-hidden");
    }else{
        element.classList.add("navbar-section-show")
        element.classList.remove("narvar-section-hidden");
    }
    
  }

  function changeMenuIcon(){
      var element = document.getElementById("menu-icon");
      if( element.classList.contains("icofont-navigation-menu") ){
        element.classList.remove("icofont-navigation-menu")
        element.classList.add("icofont-close");
      }else{
        element.classList.remove("icofont-close");
        element.classList.add("icofont-navigation-menu")
      }
  }

 function onMenuIconButtonClick(){
      showOrHideMenu();
      changeMenuIcon();
  }

  return (
    <div id="header" >
      <div >
        {/* <span type="button" className="hiddenButton d-block d-sm-block d-md-none d-lg-none" onClick={doit}>x</span> */}
        <i class="hiddenButton icofont-navigation-menu d-block d-sm-block d-md-none d-lg-none m-3" id="menu-icon" onClick={onMenuIconButtonClick} ></i>
        <div className="" >
        <div className="row m-0"  >
        
        
        <section id="navbar-section"   className="col-md-3 col-4  fixed-top  navbar-section" >
            <PortfolioHome></PortfolioHome>
        </section>
        <section   className="col-12  col-md-9 offset-md-3 p-0  ">
        <div className="parallax m-0">
            <div className="main-cover" data-aos="fade-left">
                <h3>
                
                
                </h3>
                <h3>
                <i class="bx bx-home" > I am </i>    
                </h3>
                <h1>   
                <i class="bx bx-home" > <Typed
                strings={[ 'Mohamed Adam','A Programmer' , 'A Developer' , 'And i have no life']}
                typeSpeed={50}
                backSpeed={50}
                backDelay={1000}
                smartBackspace='true'
                loop='true'
                >

                </Typed> </i>  
               
                </h1>
            </div>
        </div>
        
        <About></About>
        
        </section>
        </div>
        </div>

        
      </div>
    </div>
  );
};


/*
        <section className="main-screen">
        <section className="parallax col-9 "><h1>this is parallax</h1></section>
        
        <div className="about">main main</div>
        </section>
        <section className="col col-3 test"></section>
         <section className="navbar-section col-3 "></section> 
*/
export default Portfolio;
